export var GeographicAreaShape;
(function (GeographicAreaShape) {
    GeographicAreaShape["CIRCLE"] = "CIRCLE";
    GeographicAreaShape["RECTANGLE"] = "RECTANGLE";
    GeographicAreaShape["POLYGON"] = "POLYGON";
})(GeographicAreaShape || (GeographicAreaShape = {}));
